export const MAP_MODE = {
  BROWSER: 'mode-browser',
  FEATURES: 'mode-features',
  MOSAICS: 'mode-mosaics',
  SAVED_SEARCHES: 'mode-saved-searches',
  SEARCH: 'mode-search',
  SUBSCRIPTIONS: 'mode-subscriptions',
} as const;
